import { Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./ComplianceBar.styles";
import { useTranslation } from "react-i18next";

export const ComplianceBarPercentageReference = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.percentageReferenceContainer}>
            <div className={classes.percentageNumbers}>
                <Typography variant="h5">{t("rca.compliance.barPercentagesReference.zero")}</Typography>
                <Typography variant="h5">{t("rca.compliance.barPercentagesReference.twentyFive")}</Typography>
                <Typography variant="h5">{t("rca.compliance.barPercentagesReference.fifty")}</Typography>
                <Typography variant="h5">{t("rca.compliance.barPercentagesReference.seventyFive")}</Typography>
                <Typography variant="h5">{t("rca.compliance.barPercentagesReference.hundred")}</Typography>
            </div>
            <hr className={classes.percentageReference} />
        </div>
    );
};
